import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { User, LogOut, Settings } from 'lucide-react';
import { useUserPreferences } from '../contexts/UserPreferencesContext';
import AuthModal from './AuthModal';
import SettingsModal from './SettingsModal';

const AuthButton = ({ className = "" }) => {
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [isSettingsModalOpen, setIsSettingsModalOpen] = useState(false);
  const { user, isAuthenticated, signOut, isOnboarded } = useUserPreferences();


  const handleSignOut = async () => {
    try {
      console.log('Starting sign out process...');
      await signOut();
      console.log('Sign out completed');
    } catch (error) {
      console.error('Sign out error:', error);
    }
  };

  const getDisplayName = () => {
    if (!user) return '';
    return user.email?.split('@')[0] || user.user_metadata?.name || 'User';
  };

  if (isAuthenticated()) {
    return (
      <div className={`flex items-center space-x-2 ${className}`}>
        
        {/* Settings button - show for authenticated users */}
        {isAuthenticated() && (
          <Button
            variant="outline"
            size="sm"
            onClick={() => {
              console.log('Settings button clicked!');
              setIsSettingsModalOpen(true);
            }}
            className="flex items-center space-x-1"
          >
            <Settings className="h-4 w-4" />
            <span className="hidden sm:inline">Settings</span>
          </Button>
        )}
        
        <Button
          variant="destructive"
          size="sm"
          onClick={handleSignOut}
          className="flex items-center space-x-1"
        >
          <LogOut className="h-4 w-4" />
          <span className="hidden sm:inline">Sign out</span>
        </Button>
        
        <SettingsModal
          isOpen={isSettingsModalOpen}
          onClose={() => setIsSettingsModalOpen(false)}
        />
      </div>
    );
  }

  return (
    <>
      <Button
        variant="default"
        size="sm"
        onClick={() => setIsAuthModalOpen(true)}
        className={`flex items-center space-x-1 ${className}`}
      >
        <User className="h-4 w-4" />
        <span>Sign in</span>
      </Button>

      <AuthModal 
        isOpen={isAuthModalOpen}
        onClose={() => setIsAuthModalOpen(false)}
      />
    </>
  );
};

export default AuthButton;